let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("1P5Gx")).then(() => parcelRequire('fuBSg'));